// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tabs_tabs-container__80qqk {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  background-color: var(--m-card-background-color);
  position: relative;
  color: var(--m-text);
}
.Tabs_tabs-container__80qqk .Tabs_tab-list__9B1Gq {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--m-border-color);
  height: 50px;
  padding: 0 16px;
}
.Tabs_tabs-container__80qqk .Tabs_tab-list__tab__K56UT {
  cursor: pointer;
  position: relative;
  padding: 0 12px;
}
.Tabs_tabs-container__80qqk .Tabs_tab-list__tab__K56UT:hover {
  color: var(--m-primary);
}
.Tabs_tabs-container__80qqk .Tabs_tab-list__tab--active__mOqDW {
  font-weight: 500;
  color: var(--m-primary);
}
.Tabs_tabs-container__80qqk .Tabs_tab-list__tab--active__mOqDW::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 34px;
  height: 2px;
  width: 100%;
  background-color: var(--m-primary);
}
.Tabs_tabs-container__80qqk .Tabs_panel-list__wN9mL {
  padding: 16px;
}
.Tabs_tabs-container__content__vOMUA {
  padding: 16px 0;
  margin-top: 10px;
}
.Tabs_tabs-container__content__vOMUA .Tabs_tab-container__mGv45 {
  width: 100%;
  display: none;
}
.Tabs_tabs-container__content__vOMUA .Tabs_tab-container__mGv45.Tabs_active__oAPli {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Tabs/Tabs.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gDAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AAEI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;EACA,YAAA;EACA,eAAA;AAAR;AAEQ;EACI,eAAA;EACA,kBAAA;EACA,eAAA;AAAZ;AAEY;EACI,uBAAA;AAAhB;AAGY;EACI,gBAAA;EACA,uBAAA;AADhB;AAGgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;AADpB;AAOI;EACI,aAAA;AALR;AAQI;EACI,eAAA;EACA,gBAAA;AANR;AAQQ;EACI,WAAA;EACA,aAAA;AANZ;AAQY;EACI,cAAA;AANhB","sourcesContent":[".tabs-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    background-color: var(--m-card-background-color);\n    position: relative;\n    color: var(--m-text);\n\n \n    .tab-list {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        border-bottom: 1px solid var(--m-border-color);\n        height: 50px;\n        padding: 0 16px;\n\n        &__tab {\n            cursor: pointer;\n            position: relative;\n            padding: 0 12px;\n\n            &:hover {\n                color: var(--m-primary);\n            }\n\n            &--active {\n                font-weight: 500;\n                color: var(--m-primary);\n                \n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    top: 34px;\n                    height: 2px;\n                    width: 100%;\n                    background-color: var(--m-primary);\n                }\n            }\n        }\n    }\n\n    .panel-list {\n        padding: 16px;\n    }\n\n    &__content {\n        padding: 16px 0;\n        margin-top: 10px;\n\n        .tab-container {\n            width: 100%;\n            display: none;\n        \n            &.active {\n                display: block;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs-container": `Tabs_tabs-container__80qqk`,
	"tab-list": `Tabs_tab-list__9B1Gq`,
	"tab-list__tab": `Tabs_tab-list__tab__K56UT`,
	"tab-list__tab--active": `Tabs_tab-list__tab--active__mOqDW`,
	"panel-list": `Tabs_panel-list__wN9mL`,
	"tabs-container__content": `Tabs_tabs-container__content__vOMUA`,
	"tab-container": `Tabs_tab-container__mGv45`,
	"active": `Tabs_active__oAPli`
};
export default ___CSS_LOADER_EXPORT___;
